/**
 * IANA timezone options for schedule pickers. Full runtime list where the
 * engine exposes it, with a fallback set for engines that don't. The browser's
 * own zone is always present and is the sensible default selection.
 *
 * Shared by every "run this at HH:mm in <zone>" control (ads QA, custom-report
 * Slack digests) so they offer the same vocabulary.
 */
const BROWSER_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone

export { BROWSER_TZ }

export const TIMEZONE_OPTIONS = (() => {
  const zones =
    typeof Intl.supportedValuesOf === "function"
      ? Intl.supportedValuesOf("timeZone")
      : [
          "UTC",
          "America/New_York",
          "America/Chicago",
          "America/Denver",
          "America/Los_Angeles",
          "Europe/London",
          "Europe/Istanbul",
        ]
  const all = zones.includes(BROWSER_TZ) ? zones : [BROWSER_TZ, ...zones]
  return all.map(zone => ({ value: zone, label: zone.replace(/_/g, " ") }))
})()
